import { createContext, useContext, useState } from 'react';

const LanguageContext = createContext({ lang: 'en', setLang: () => {}, t: (en) => en });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(localStorage.getItem('dq_lang') || 'en');
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem('dq_lang', l);
  };
  const t = (en, hi) => (lang === 'hi' && hi ? hi : en);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export const LanguageToggle = () => {
  const { lang, setLang } = useLanguage();
  return (
    <div
      className="flex items-center rounded-full border border-purple-400/40 bg-purple-900/50 backdrop-blur-md overflow-hidden text-sm"
      data-testid="language-toggle"
    >
      <button
        onClick={() => setLang('en')}
        data-testid="lang-en-btn"
        className={`px-3 py-1.5 font-semibold transition-colors ${
          lang === 'en' ? 'bg-purple-600 text-white' : 'text-purple-300 hover:text-white'
        }`}
      >
        EN
      </button>
      <button
        onClick={() => setLang('hi')}
        data-testid="lang-hi-btn"
        className={`px-3 py-1.5 font-semibold transition-colors ${
          lang === 'hi' ? 'bg-purple-600 text-white' : 'text-purple-300 hover:text-white'
        }`}
      >
        हिं
      </button>
    </div>
  );
};
